import Utility from "common/utilities";
import { ISystemHeaderBaseProp } from "Model/UI";
import React from "react";
import "./AccessApprovalsHeader.scss";
import { Constants } from "common/constants";
import { Header7 } from "Components2/HeaderTemplates/Header7/Header7";
import { IAccessApprovals } from "Model/ServerResponse/IAccessApprovals";

export interface IAccessApprovalsHeaderData extends ISystemHeaderBaseProp {
  accessApprovals: IAccessApprovals;
}

export function AccessApprovalsHeader(props: IAccessApprovalsHeaderData) {
  function getHeaderUI() {
    return (
      <Header7
        label1={"AccessNow"}
        label2={Utility.formatDate(props.accessApprovals.date, Constants.DD_MM_YY)}
        label3={props.accessApprovals.title}
        userDetails={{
          userId: props.accessApprovals.requestorID,
          userCardName: props.accessApprovals.requestor,
          userOrganization : props.accessApprovals.type
        }}
        className={Utility.mergeCssClassNames(["access-approvals-header"])}
      ></Header7>
    );
  }
  return getHeaderUI();
}
